export const getReportsIsFetching = state => state.reportsReducer.isFetching;
export const getReportsError = state => state.reportsReducer.error;

export const getReports = state => state.reportsReducer.reports;
export const getSingleReport = (state, id) => state.reportsReducer.reports[id];
